/*
* @Author: msmiller
* @Date:   2018-11-23 16:21:41
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2018-10-29 11:14:42
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
      // console.log("-=> timeago_controller connected");

      $("time.timeago").timeago();
      $(".timeago_content").fadeIn('slow');

      (function run_timeago() {
        setTimeout(function() {
          $("time.timeago").timeago();
        }, 60000);
      })();

    }

    initialize() {

      jQuery.timeago.settings.strings["en"] = {
        prefixAgo: null,
        prefixFromNow: null,
        suffixAgo: "",
        suffixFromNow: "",
        seconds: "<1m",
        minute: "1m",
        minutes: "%dm",
        hour: "1h",
        hours: "%dh",
        day: "1d",
        days: "%dd",
        month: "1mo",
        months: "%dmo",
        year: "1yr",
        years: "%dyr",
        wordSeparator: " ",
        numbers: []
      };

    }

  };

// console.log("-=> timeago_controller loaded");

